// extracted by mini-css-extract-plugin
module.exports = {"module":"NumberStepper_module__35R2n","number":"NumberStepper_number__2BRA_","nr":"NumberStepper_nr__X5CO6","additionnalInfo":"NumberStepper_additionnalInfo__VLCHD"};